import React, { useState, useRef, useEffect } from "react";
import "../styles/UserProfile.css";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [myData, setMyData] = useState({ name: "사용자", grade: "NEW", totalPurchaseAmount: 0, point: 0, couponCount: 0 });
    const [isGradeVisible, setIsGradeVisible] = useState(false);
    const gradeRef = useRef(null);

    const GRADE_LIST = [
        { id:1, level: "NEW", min: 0, max: 50000, description: "텍스트 텍스트" },
        { id:2, level: "WELCOME", min: 50001, max: 100000, description: "텍스트 텍스트" },
        { id:3, level: "VIP", min: 100001, max: 500000, description: "텍스트 텍스트" },
        { id:4, level: "VVIP", min: 500001, max: 999999999, description: "텍스트 텍스트" },
        { id:5, level: "ADMIN", min: 0, max: 999999999, description: "텍스트 텍스트" },
        ];

    const getGradeIndex = (grade) => GRADE_LIST.findIndex(g => g.level === grade);


    // ✅ **외부 클릭 감지하여 등급창 닫기**
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("/api/mypage/info");
                if (response.ok) {
                    const data = await response.json();
                    setMyData(data.myManagementData !== "noData" ? data.myManagementData : []);
                } else {
                    console.error("마이페이지 데이터를 불러오는데 실패했습니다.");
                }
            } catch (error) {
                console.error("API 요청 중 오류 발생:", error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchData();

        const handleClickOutside = (event) => {
            if (gradeRef.current && !gradeRef.current.contains(event.target)) {
                setIsGradeVisible(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const prevGrade = (grade) => {
        const index = getGradeIndex(grade);
        return index > 0 ? GRADE_LIST[index - 1].level : ""; // 이전 등급
    };

    const nextGrade = (grade) => {
        const index = getGradeIndex(grade);
        return index < GRADE_LIST.length - 1 ? GRADE_LIST[index + 1].level : ""; // 다음 등급
    };

    // 진행률 계산
    const getProgress = (total) => {
        const currentGrade = GRADE_LIST.find(g => g.level === myData.grade);
        if (!currentGrade) return 0; // 등급을 찾지 못하면 0%

        const min = currentGrade.min;
        const max = currentGrade.max;

        // 진행률 계산
        let progress = ((total - min) / (max - min)) * 100;

        // 0% ~ 100% 사이 값으로 제한
        return Math.max(0, Math.min(100, progress));
    };


    if (isLoading) return <p>로딩 중...</p>;

    return (
        <div className="user-profile">
            {/* 프로필 정보 */}
            <div className="profile-section">
                <img src="/images/softcat2_x75.png" alt="User Avatar" className="user-avatar" />
                <p className="user-greeting">{myData.name}님의 회원등급은 {myData.grade} 입니다.</p>
            </div>

            {/* 유저 스탯 */}
            <div className="user-stats">
                <div className="user-stat user-stat-grade" ref={gradeRef}>
                    <span className="stat-label" role="button" onClick={() => setIsGradeVisible(!isGradeVisible)}>
                        등급
                        <img src="/images/icon/grade_icon.png" alt="grade" className="grade-icon" />
                    </span>
                    <span className="stat-value">{myData.grade}</span>

                    {/* 🔥 등급 상세 정보 (Dropdown) */}
                    {isGradeVisible && (
                        <div className="grade-dropdown">
                            <div className="grade-arrow"></div>

                            <div className="grade-header">
                                <div className="grade-icon-wrapper">
                                    <img src="/images/icon/new_grade.png" alt="현재 등급" className="current-grade-icon" />
                                </div>
                                <p className="grade-title-text">
                                    {myData.name}님의 회원등급은 <strong>{myData.grade}</strong> 입니다
                                </p>
                                <p className="grade-points">누적 금액 {myData.totalPurchaseAmount}원</p>

                                {/* 🔹 프로그레스 바 */}
                                <div className="grade-progress">
                                    <div className="progress-bar">
                                        <div
                                            className="progress-fill"
                                            style={{ width: `${getProgress(myData.totalPurchaseAmount)}%` }}
                                        ></div>
                                    </div>
                                    <div className="progress-info">
                                        <span>{myData.totalPurchaseAmount} / {GRADE_LIST.find(g => g.level === myData.grade)?.max}원</span>
                                    </div>
                                    <div className="grade-levels">
                                        {myData.grade === "ADMIN" || myData.grade === "NEW" ? <span>X</span> : <span>{prevGrade(myData.grade)}</span>}
                                        <span>{myData.grade}</span>
                                        {myData.grade === "ADMIN" || myData.grade === "VVIP" ? <span>X</span> : <span>{nextGrade(myData.grade)}</span>}
                                    </div>
                                </div>
                            </div>

                            {/* 🔹 회원 등급 기준 */}
                            <h3 className="grade-title">회원등급 기준</h3>
                            <div className="grade-list">
                                {["new", "welcome", "vip", "vvip"].map((level, index) => (
                                    <div key={index} className="grade-card">
                                        <img src={`/images/icon/${level.toLowerCase()}_grade.png`} alt={level} />
                                        <h4>{level}</h4>
                                        <p>{GRADE_LIST[index].min}원 이상</p>
                                        <p className="grade-text">텍스트 텍스트</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="divider"></div>
                <div className="user-stat">
                    <span className="stat-label" role="button" onClick={() => navigate("/mypage/check-point")}>
                        포인트
                        <img src="/images/icon/grade_icon.png" alt="grade" className="grade-icon" />
                    </span>
                    <span className="stat-value">{myData.point}P</span>
                </div>
                <div className="divider"></div>
                <div className="user-stat">
                    <span className="stat-label" role="button" onClick={() => navigate("/mypage/check-coupon")}>
                        쿠폰
                        <img src="/images/icon/grade_icon.png" alt="grade" className="grade-icon" />
                    </span>
                    <span className="stat-value">{myData.couponCount}개</span>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;
